export const DiscountTypesEnum = {
  LiveShopping: 1,
  TippsDiscount: 2,
};
